import { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Context/AuthContext';
import { peicarLogoFull } from '../../../Assets/Images';
import AlertsBell from '../Alerts/AlertsBell';
import ProfilePopover from '../../../Components/Header/ProfilePopover';
import { url } from '../../../env';
import { adminHeaderCSS } from './AdminHeader.css';

const ROLE_LABELS = {
    '1': 'Admin Pei',
    '2': 'Vendedor Pei',
    '3': 'Admin Trim',
    '4': 'Vendedor Trim',
};

const dashboardPathFor = (typeUser) => {
    const t = String(typeUser ?? '');
    if (t === '1') return '/admin';
    if (t === '3') return '/admin-trim';
    if (t === '2' || t === '4') return '/vendedor';
    return '/';
};

const getInitials = (name = '') =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase())
        .join('') || '?';

export const AdminHeader = ({ pageTitle = 'Dashboard', onToggleMobileNav, logoHref, logoSrc }) => {
    const { authInfo, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const user = authInfo?.user;
    const name = user?.name || 'Usuario';
    const typeUser = String(user?.type_user ?? '');
    const role = ROLE_LABELS[typeUser] || '';
    const isAdminPei = typeUser === '1';

    const [profileOpen, setProfileOpen] = useState(false);

    const handleGoDashboard = () => {
        navigate(dashboardPathFor(typeUser));
    };

    const logo = (
        <img
            className={logoSrc ? 'ah-logo ah-logo--compact' : 'ah-logo'}
            src={logoSrc || peicarLogoFull}
            alt="Peicar"
        />
    );

    const handleLogout = async () => {
        try {
            const token = localStorage.getItem('token');
            await fetch(`${url}/logout`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
        } catch (e) {
            // best-effort
        }
        logout();
        navigate('/login');
    };

    return (
        <header css={adminHeaderCSS()}>
            <div className="ah-left">
                <button
                    type="button"
                    className="ah-hamburger"
                    onClick={onToggleMobileNav}
                    aria-label="Abrir menú de navegación"
                >
                    <i className="pi pi-bars" />
                </button>
                {logoHref ? (
                    <Link to={logoHref} className="ah-logo-link" aria-label="Ir al inicio">
                        {logo}
                    </Link>
                ) : (
                    logo
                )}
                <span className="ah-divider" />
                <span className="ah-page-title">{pageTitle}</span>
            </div>

            <div className="ah-right">
                {isAdminPei && (
                    <div className="ah-bell-slot">
                        <AlertsBell />
                    </div>
                )}
                <button
                    type="button"
                    className="ah-profile"
                    onClick={() => setProfileOpen((p) => !p)}
                    aria-haspopup="menu"
                    aria-expanded={profileOpen}
                >
                    <div className="ah-avatar">{getInitials(name)}</div>
                    <div className="ah-profile-meta">
                        <div className="ah-name">{name}</div>
                        <div className="ah-role">{role}</div>
                    </div>
                </button>
                <ProfilePopover
                    open={profileOpen}
                    onClose={() => setProfileOpen(false)}
                    user={user}
                    onGoDashboard={handleGoDashboard}
                    onLogout={handleLogout}
                />
            </div>
        </header>
    );
};

export default AdminHeader;
